import { alpha, Stack, stackClasses, Typography } from "@mui/material";
import { MaterialImage } from "../material-components";
import { StaticImageData } from "next/image";
import { MotionStack } from "../motion-components";

export interface AwardCardProps {
  imageUrl: StaticImageData | string;
  title: string;
  subTitle: string;
}

const AwardCard = (props: AwardCardProps) => {
  const { imageUrl, title, subTitle, ...restProps } = props;
  return (
    <MotionStack
      position={"relative"}
      alignItems={"center"}
      width={1}
      sx={{
        [`.${stackClasses.root}`]: {
          bgcolor: alpha("#fff", 0.1),
          transition: "all .3s ease-out",
        },
        "&:hover": {
          color: (theme) => theme.palette.primary.main,
          [`.${stackClasses.root}`]: {
            bgcolor: alpha("#fff", 1),
          },
          img: {
            transform: "scale(1.3)",
            transformOrigin: "bottom",
          },
        },
      }}
      {...restProps}
    >
      <MaterialImage
        src={imageUrl}
        alt="awards"
        width={92}
        height={209}
        sx={{
          width: { xs: 79, md: 94 },
          height: { xs: 169, md: 209 },
          mb: "-12%",
          zIndex: 1,
          transform: "scale(1)",
          transition: "all .3s ease-out",
        }}
      />
      <Stack
        p={3}
        pt={8}
        rowGap={2}
        justifyContent={"center"}
        alignItems={"center"}
        textAlign={"center"}
        minHeight={207}
        height={287}
      >
        <Typography variant="h6" fontSize={"18px !important"}>
          {title}
        </Typography>
        <Typography fontSize={"16px !important"} textAlign={"justify"}>{subTitle}</Typography>
      </Stack>
    </MotionStack>
  );
};

export default AwardCard;
